// Correspondance entre les libellés de maintenance du frontend et les valeurs
// réellement acceptées par Supabase (table `maintenances`).
//
// Côté base :
//   priorite : basse | normale | haute | urgente
//   statut   : ouverte | en_cours | en_attente | terminee | annulee
//
// Côté interface (historique) :
//   priorite : faible | normale | elevee | urgente
//   statut   : nouveau | en-cours | en-attente | termine | annule
//
// Le mapping ci-dessous évite toute perte de sens métier : chaque état du
// frontend dispose d'un équivalent base dédié (`en-attente` → `en_attente`).

export type FrontPriorite = "faible" | "normale" | "elevee" | "urgente";
export type FrontStatut = "nouveau" | "en-cours" | "en-attente" | "termine" | "annule";

const PRIORITE_TO_DB: Record<FrontPriorite, string> = {
  faible: "basse",
  normale: "normale",
  elevee: "haute",
  urgente: "urgente",
};

const PRIORITE_FROM_DB: Record<string, FrontPriorite> = {
  basse: "faible",
  normale: "normale",
  haute: "elevee",
  urgente: "urgente",
};

const STATUT_TO_DB: Record<FrontStatut, string> = {
  nouveau: "ouverte",
  "en-cours": "en_cours",
  "en-attente": "en_attente",
  termine: "terminee",
  annule: "annulee",
};

const STATUT_FROM_DB: Record<string, FrontStatut> = {
  ouverte: "nouveau",
  en_cours: "en-cours",
  en_attente: "en-attente",
  terminee: "termine",
  annulee: "annule",
};

export function prioriteToDb(value: string): string {
  return PRIORITE_TO_DB[value as FrontPriorite] ?? "normale";
}

export function prioriteFromDb(value: string): FrontPriorite {
  return PRIORITE_FROM_DB[value] ?? "normale";
}

export function statutToDb(value: string): string {
  return STATUT_TO_DB[value as FrontStatut] ?? "ouverte";
}

export function statutFromDb(value: string): FrontStatut {
  return STATUT_FROM_DB[value] ?? "nouveau";
}

/** Photos stockées en jsonb (tableau de chaînes) côté base. */
export function photosFromDb(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === "string");
  }
  return [];
}